<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
  isOpen: boolean
  mode: 'create' | 'rename'
  initialName?: string
  parentName?: string | null
}>()

const emit = defineEmits<{
  (e: 'cancel'): void
  (e: 'save', name: string): void
}>()

const name = ref('')

watch(
  () => props.isOpen,
  (open) => {
    if (open) name.value = props.initialName ?? ''
  },
)

function submit() {
  const trimmed = name.value.trim()
  if (!trimmed) return
  emit('save', trimmed)
}
</script>

<template>
  <div v-if="isOpen" class="fixed inset-0 z-[60] flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-black/40" @click="emit('cancel')" />
    <div class="relative w-full max-w-md bg-white p-6 shadow-xl">
      <h3 class="text-lg font-semibold text-slate-900">
        {{ mode === 'create' ? 'Nova área' : 'Renomear área' }}
      </h3>
      <p v-if="parentName && mode === 'create'" class="mt-1 text-sm text-slate-500">
        Dentro de <strong>{{ parentName }}</strong>
      </p>

      <form class="mt-4 space-y-4" @submit.prevent="submit">
        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700">Nome da área</label>
          <input
            v-model="name"
            type="text"
            autofocus
            class="w-full border border-zinc-300 px-4 py-2.5 focus:border-primary focus:outline-none"
            placeholder="Ex.: Transformador 2, Refrigeração, Linha 1" />
        </div>

        <div class="flex justify-end gap-3">
          <button
            type="button"
            class="border border-stroke px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            @click="emit('cancel')">
            Cancelar
          </button>
          <button
            type="submit"
            :disabled="!name.trim()"
            class="bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90 disabled:opacity-50">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
